"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_options_core_2 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(optionState.showPreviewTextInListView, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.onMessagePreviewToggle = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function saveMessagePreviewOptionFull(isToggleEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions;
                    return [4 /*yield*/, saveMessagePreviewOption(isToggleEnabled, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveMessagePreviewOption = legacy_1.action('saveMessagePreviewOption')(function saveMessagePreviewOption(isEnabled, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions.ShowPreviewTextInListView = owa_options_core_1.getFallbackValueIfNull(isEnabled, userOptions.ShowPreviewTextInListView);
                    return [4 /*yield*/, owa_options_core_2.updateUserConfiguration([
                            {
                                propertyName: 'ShowPreviewTextInListView',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowPreviewTextInListView,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMessagePreviewOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/actions/saveMessagePreviewOption.js
// module id = 5110
// module chunks = 2